// Times are shown in the employee's office timezone (not the viewer's browser),
// so everyone reads the same clock time. Offices without a timezone use Manila.
export const DEFAULT_TZ = "Asia/Manila";

const validTz = (tz) => {
  try {
    new Intl.DateTimeFormat("en-GB", { timeZone: tz });
    return true;
  } catch (e) {
    return false;
  }
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const parts = (v, tz) => {
  const zone = tz && validTz(tz) ? tz : DEFAULT_TZ;
  const o = {};
  new Intl.DateTimeFormat("en-GB", { timeZone: zone, hourCycle: "h23", day: "2-digit", month: "numeric", hour: "2-digit", minute: "2-digit" })
    .formatToParts(new Date(v))
    .forEach((p) => { o[p.type] = p.value; });
  return o;
};

export const formatTimeInTz = (v, tz) => {
  if (!v) return "-";
  const p = parts(v, tz);
  return `${p.hour}:${p.minute}`;
};

export const formatDateTimeInTz = (v, tz) => {
  if (!v) return "-";
  const p = parts(v, tz);
  return `${p.day} ${MONTHS[Number(p.month) - 1]}, ${p.hour}:${p.minute}`;
};

export const tzLabel = (tz) => (tz && validTz(tz) ? tz : DEFAULT_TZ).replace(/_/g, " ");
